import Service from "./Service";
import { AdviseEntity, ExtraInfoEntity } from "@/model/Adapter";
import { PageList } from "@/model/system";
class AdapterService extends Service {
  saveAdviseInfo(data: AdviseEntity) {
    return this.post<number>("/advise/update", data);
  }
  //{"ExtraCode":"App-Trundle","App-Round-Image"}
  getIndexExtras(data: ExtraInfoEntity) {
    return this.post<PageList<ExtraInfoEntity>>("/ExtraInfo/IndexExtras", data);
  }
  checkApproval(data: any) {
    return this.post(`/EmailProject/detail`, data);
  }
  searchUserBudgetInfo(certNo:string) {
    return this.post(`/budget/SearchUserBudgetInfo?certNo=${certNo}`,'');
  }
}
export default new AdapterService("adapter");
